__turbopack_context__.v({
  "eyebrow": "pricing-addons-module__u7NsbG__eyebrow",
  "grid": "pricing-addons-module__u7NsbG__grid",
  "mcpFee": "pricing-addons-module__u7NsbG__mcpFee",
  "note": "pricing-addons-module__u7NsbG__note",
  "section": "pricing-addons-module__u7NsbG__section",
  "usageFees": "pricing-addons-module__u7NsbG__usageFees",
});
